import { motion } from "framer-motion";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import DealertrackCreditApp from "@/components/DealertrackCreditApp";
import { useTranslation } from "@/hooks/useTranslation";
import { useTheme } from "@/contexts/ThemeContext";

export default function FinancingPage() {
  const { t } = useTranslation();
  const { isDark } = useTheme();

  return (
    <div className={`min-h-screen transition-colors duration-300 ${isDark ? "bg-[#050505]" : "bg-[#FAFAFA]"}`} data-testid="financing-page">
      <Navbar />

      <div className={`pt-24 pb-12 ${isDark ? "radial-gradient" : ""}`}>
        <div className="max-w-5xl mx-auto px-6 md:px-12">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
            <span className={`text-sm uppercase tracking-widest font-medium mb-3 block ${isDark ? "text-blue-500" : "text-red-600"}`}>
              {t("financing.tagline")}
            </span>
            <h1 className={`font-unbounded text-3xl md:text-4xl lg:text-5xl font-bold mb-4 ${isDark ? "text-white" : "text-gray-900"}`}>
              {t("financing.title")}
            </h1>
            <p className={`text-lg max-w-2xl ${isDark ? "text-gray-400" : "text-gray-600"}`}>
              {t("financing.description")}
            </p>
          </motion.div>
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-6 md:px-12 pb-24">
        <DealertrackCreditApp />
      </div>

      <Footer />
    </div>
  );
}
